import { PropsWithChildren } from 'react'

import {
  Backdrop,
  Container,
  Description,
  Divider,
  FormModalContent,
  Header,
  HeaderText,
  Overlay,
  Title
} from './FuelFormModal.styles'

interface FuelFormModalProps {
  title: string
  description?: string
  onClose: () => void
}

function FuelFormModal({ title, description, onClose, children }: PropsWithChildren<FuelFormModalProps>) {
  return (
    <Overlay>
      <Backdrop onClick={onClose} />
      <Container>
        <Header>
          <HeaderText>
            <Title>{title}</Title>
            {description && <Description>{description}</Description>}
          </HeaderText>
        </Header>

        <Divider />

        <FormModalContent>{children}</FormModalContent>
      </Container>
    </Overlay>
  )
}

export { FuelFormModal }
